import React, { useContext } from 'react';

import SignInOutButton from './SignInOutButton';
import { BOOKINGS_VIEWS } from '../../../Bookings';
import { TabContext } from "../../../Pages/BookingsLog";

const StatusCell = (props) => {
    const tabState = useContext(TabContext);

    if (!props.row) {
        return null;
    }

    if (props.row.user.deleted) {
        return null;
    }

    if (props.row.booked_config.sign_in_enabled
        && props.row.can_edit_status
        && tabState.view === BOOKINGS_VIEWS.ALL_BOOKINGS
        && !props.row.archived_at
    ) {
        return (
            <SignInOutButton
                booking={props.row}
                view={tabState.view}
                scope={tabState.scope}
            />
        )
    } else {
        return (
            <>{ props.row.status }</>
        )
    }
}

export default StatusCell;
